import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import App from './App';
import './motion/motion.css';
import { initReveal } from './motion/reveal';

// Nota: el HTML de producción viene prerenderizado (scripts/prerender.mjs) para que
// los buscadores y crawlers de IA vean contenido sin ejecutar JS. En el navegador,
// React vuelve a renderizar el árbol completo sobre ese HTML.
// Animaciones de aparición al hacer scroll (no se activan en el prerender ni con reduced-motion).
if (!window.__PRERENDERING__) {
    initReveal();
}

const root = createRoot(document.getElementById('root'));
root.render(
    <HelmetProvider>
        <App />
    </HelmetProvider>
);
